import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=da27b8aa&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=da27b8aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da27b8aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da27b8aa')) {
      api.createRecord('da27b8aa', component.options)
    } else {
      api.reload('da27b8aa', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=da27b8aa&scoped=true&", function () {
      api.rerender('da27b8aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2d2LGzIQamwa1/JS/comp/SearchFilterTokens.vue"
export default component.exports